import { render, staticRenderFns } from "./ProfileManagement.vue?vue&type=template&id=b8b83880&scoped=true&"
import script from "./ProfileManagement.vue?vue&type=script&lang=js&"
export * from "./ProfileManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProfileManagement.vue?vue&type=style&index=0&id=b8b83880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b83880",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VRow,VTooltip})
